import { render, staticRenderFns } from "./NotiCenter.vue?vue&type=template&id=dcf01c38&scoped=true&"
import script from "./NotiCenter.vue?vue&type=script&lang=js&"
export * from "./NotiCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotiCenter.vue?vue&type=style&index=0&id=dcf01c38&lang=scss&scoped=true&"
import style1 from "./NotiCenter.vue?vue&type=style&index=1&id=dcf01c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf01c38",
  null
  
)

export default component.exports